import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';

import axios from 'axios';
import { formatMoneda, formatoMonto, validaMonto, validaSoloNumero } from '../../util/varios';
import CatalogoClassPresupuestaria from '../../catalogos/catalogoClassPresupuestario';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';


export const PresupuestoClasificador = (props) => {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const idusuario = JSON.parse(localStorage.getItem('idusuario'));
    const fechaSistema = JSON.parse(localStorage.getItem('fechasistema'));

    const [activate, setActivate] = useState(false);
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [mostrar3, setMostrar3] = useState(false);
    const [mostrar4, setMostrar4] = useState(false);
    const [val, setVal] = useState(0);
    const [val2, setVal2] = useState(0);
    const [activo, setActivo] = useState(true);
    const [activod, setActivod] = useState(true);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [values, setValues] = useState({
        idcuenta: "",
        auxiliar: "",
        descripcionaux: "",
        idcategoriaprogramatica: "",
        idpuc: "",
        puc: "",
        categoria: "",
        disponibilidad: 0.00,
        montoinicial: 0.00,
        tipopartida: "",

    });
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtId = useRef();
    const txtTipoPartidai = useRef();
    const txtTipoPartidag = useRef();
    const txtPuc = useRef();
    const txtDescriclas = useRef();
    const txtMonto = useRef();
    const txt6 = useRef();
    const txt7 = useRef();
    const txt8 = useRef();
    const txt9 = useRef();
    const txtBtnSu = useRef();

    const onChange = (event) => {


    };

    const onCheck = () => {

        if (txtTipoPartidai.current.checked) {
            setVal(100000000);
            setVal2(399999999);
            setActivo(false);
            setActivod(false);
        } else if (txtTipoPartidag.current.checked) {
            setVal(400000000);
            setVal2(999999999);
            setActivo(false);
            setActivod(false);
        }

    }

    const cancelar = () => {
        blanquear();
        props.onHideCancela();
    }

    const blanquear = () => {
        setValues({
            idcuenta: "",
            auxiliar: "",
            descripcionaux: "",
            idcategoriaprogramatica: "",
            idpuc: "",
            puc: "",
            categoria: "",
            disponibilidad: 0.00,
            montoinicial: 0.00,
            tipopartida: "",

        });
        setActivate(false);
        setActivo(true);
        setActivod(true);
    };


    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        props.onHideRenderizar();
        props.onHideCancelar();
        blanquear();
    }

    const catalogoClass = (e) => {
        e.preventDefault();
        setMostrar4(true);
    };

    const handleInputNumChange = (event) => {
        event.preventDefault();
        validaSoloNumero(event);

        if (event.which === 13 || typeof (event.which) === 'undefined') {

            setValues({ ...values, [event.target.name]: event.target.value });

        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;
    };

    const handleInputMontoChange = (event) => {
        validaMonto(event);
        if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
            event.target.value = '0,00'
        }
        if (event.which >= 37 && event.which <= 40) {
            event.preventDefault();
        }

        if (event.which === 13) {
            if (event.target.id === 'monto') {
                txtMonto.current.focus();
            }
        }
        // Devuelve el número formateado
        let e = event.target.value.replace(/\D/g, "")
            .replace(/([0-9])([0-9]{2})$/, '$1.$2')
            .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");

        return formatMoneda(e)
    };

    const handleAceptaClasPresupuestaria = (idpuc, descripcion, puc) => {
        setMostrar3(false);
        txtMonto.current.removeAttribute('disabled')
        txtDescriclas.current.value = descripcion.trim();
        txt6.current.value = puc.substring(0, 3);
        txt7.current.value = puc.substring(3, 5);
        txt8.current.value = puc.substring(5, 7);
        txt9.current.value = puc.substring(7, 9);
        txtId.current.value = idpuc.trim();
        txtPuc.current.value = puc.trim();
        txtMonto.current.focus()
    }

    const handleCancelaras = () => {
        setMostrar4(false);
    }

    const seleccionarClassPresupuestaria = () => {
        blanquear();
        let sigue = true;
        if (txt6.current.value == '') {
            setMensaje({ mostrar: true, titulo: 'Información', texto: 'Debe seleccionar el Clasificador Presupuestario', icono: 'informacion' });
            txtBtnSu.current.focus()
            sigue = false;
        }

        if (sigue) {
            var datos = [];
            datos.push({
                uno: txt6.current.value,
                dos: txt7.current.value,
                tres: txt8.current.value,
                cuatro: txt9.current.value,
                descripcion: txtDescriclas.current.value,
                monto: txtMonto.current.value === '' ? '0,00' : txtMonto.current.value,
                id: txtId.current.value,
                puc: txtPuc.current.value
            })
            props.onDatos(datos);
            props.onHideCancela();
        }
    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                setOperacion(props.operacion);
                if (props.operacion !== 1) {
                    setValues(props.presu);
                } else {
                    if (props.modal !== 'obra') {
                        txtTipoPartidag.current.checked = false;
                        txtTipoPartidai.current.checked = false;
                    }
                    txtDescriclas.current.value = "";
                    txt6.current.value = "";
                    txt7.current.value = "";
                    txt8.current.value = "";
                    txt9.current.value = "";
                }

                if (props.modal === 'obra') {
                    setVal(400000000);
                    setVal2(999999999);
                    setActivo(false);
                    setActivod(false);
                }

                if (props.modal !== 'obra') {
                    setVal(400000000);
                    setVal2(999999999);
                    setActivo(false);
                    setActivod(false);
                    txtTipoPartidag.current.checked = true;
                }

            }}

        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className='fw-bold text-light'><h3>{operacion === 1 ? 'Selección de Cuenta.' : operacion === 2 ? 'Editar Presupuesto.' : operacion === 3 ? 'Eliminar Presupuesto.' : 'Consultar Presupuesto.'}</h3></div>
                <button className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>

            </Modal.Header>
            <Modal.Body>
                <CatalogoClassPresupuestaria
                    show={mostrar4}
                    val={val}
                    vals={val2}
                    onHideCancelar={handleCancelaras}
                    onHideAceptaClasPresupuestaria={handleAceptaClasPresupuestaria}
                />
                <Dimmer active={activate} inverted>

                </Dimmer>
                <div>

                    <input type='hidden' ref={txtId} />
                    <input type='hidden' ref={txtPuc} />

                    {props.modal !== '' ? <fieldset className="row border-azul rounded mx-auto col-sm-7">
                        <legend className="float-none m-0 fw-bold w-auto" style={{ fontSize: 15 }}>Tipo de Partida</legend>

                        <div className="form-check col-sm-4 ml-auto">
                            <input className="form-check-input" disabled={operacion === 4 || operacion === 2 ? true : deshabilitado} type="radio" ref={txtTipoPartidai} onChange={onCheck} /* defaultChecked={props.presu && props.presu.tipopartida === 0 ? true : true} */ name="exampleRadios" id="exampleRadios1" value="option1" />
                            <label className="form-check-label" for="exampleRadios1">
                                Ingresos
                            </label>
                        </div>
                        <div className="form-check col-sm-4 ml-auto">
                            <input className="form-check-input" disabled={operacion === 4 || operacion === 2 ? true : deshabilitado} type="radio" ref={txtTipoPartidag} onChange={onCheck} name="exampleRadios" id="exampleRadios2" value="option2" defaultChecked />
                            <label className="form-check-label" for="exampleRadios2">
                                Gastos
                            </label>
                        </div>

                    </fieldset> : ''}

                    <div className='col-md-12 py-2'></div>

                    <fieldset className="row border-azul rounded mx-auto mb-1">
                        <legend className="float-none m-0 fw-bold w-auto" style={{ fontSize: 15 }}>Clasificador Presupuestario</legend>






                        <div className="input-group input-group-sm col-md-7 my-auto">
                            <label className="input-group-text" id="inputGroup-sizing-sm">Ramo:</label>
                            <input type="text" disabled={true} maxLength="3" name='uno' ref={txt6} onChange={onChange} onChangeCapture={handleInputNumChange} defaultValue={props.claspre ? props.claspre.puc.substring(0, 3) : ''} className="form-control text-uppercase mr-1" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputLogin" />

                            <label className="input-group-text" id="inputGroup-sizing-sm">Gen:</label>
                            <input type="text" disabled={true} maxLength="2" name='dos' ref={txt7} onChange={onChange} onChangeCapture={handleInputNumChange} defaultValue={props.claspre ? props.claspre.puc.substring(3, 5) : ''} className="form-control text-uppercase mr-1" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputLogin" />

                            <label className="input-group-text" id="inputGroup-sizing-sm">Espec:</label>
                            <input type="text" disabled={true} maxLength="2" name='tres' ref={txt8} onChange={onChange} onChangeCapture={handleInputNumChange} defaultValue={props.claspre ? props.claspre.puc.substring(5, 7) : ''} className="form-control text-uppercase mr-1" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputLogin" />

                            <label className="input-group-text" id="inputGroup-sizing-sm">SubEsp:</label>
                            <input type="text" disabled={true} maxLength="2" name='cuatro' ref={txt9} onChange={onChange} onChangeCapture={handleInputNumChange} defaultValue={props.claspre ? props.claspre.puc.substring(7, 9) : ''} className="form-control text-uppercase mr-1" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputLogin" />
                            <button onClick={catalogoClass} ref={txtBtnSu} className="btn btn-sm  btn-info" ><i className="fa fa-search"></i> </button>

                        </div>

                        <div className='col-md-5'></div>




                        <div className="input-group input-group-sm col-md-12 my-auto pt-1">
                            <label className="input-group-text" id="inputGroup-sizing-sm">Descripción:</label>
                            <textarea type="textarea" style={{ height: 70 }} className="form-control text-uppercase" disabled={true} ref={txtDescriclas} defaultValue={props.claspre ? props.claspre.descripcion : ''} placeholder="Descripción del Clasificador Presupuestario" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputDireccion" />
                        </div>



                        <div className='col-md-9'></div>
                        <div className="input-group input-group-sm col-md-3 my-auto pt-1">
                            <label className="input-group-text" id="inputGroup-sizing-sm">Monto:</label>
                            <input type="text" autoComplete='off' disabled className="form-control text-right" ref={txtMonto} defaultValue={values && values.montoinicial ? formatMoneda(values.montoinicial.toString().replace(',', '').replace('.', ','), ',', '.', 2) : ''} onBlur={handleInputMontoChange} onKeyUp={handleInputMontoChange} placeholder="0,00" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="monto" />
                        </div>


                    </fieldset>

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" ref={btnAcepta} onClick={seleccionarClassPresupuestaria} style={{ margin: '1px' }} className="fw-bold btn btn-success btn-sm rounded-pill"><i className="far fa-check-circle"></i> Aceptar</button>
                <button type="button" ref={btnCancela} onClick={cancelar} style={{ margin: '1px' }} className="fw-bold btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"></i> Cancelar</button>
            </Modal.Footer>
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === 'Exito.' ?
                        cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />

        </Modal>

    );
}